<script setup>
import { provide } from 'vue'

const props = defineProps(({
  elementType: {
    type: String,
    default: 'ul'
  }
}))

provide('elementType', props.elementType);

</script>
<template>
    <component :is="elementType" class="jwx-toggle-list">
      <slot></slot>
    </component>
</template>